// extracted by mini-css-extract-plugin
module.exports = {"lite":"ProductsPaymentAddressInput__lite___BDZhy","button":"ProductsPaymentAddressInput__button___1b_QW"};